module.exports = __webpack_public_path__ + "img/status-support.76b80cca.png";